import { render, staticRenderFns } from "./JdhAttachedModalPopup.vue?vue&type=template&id=0bc8bdde&scoped=true&"
import script from "./JdhAttachedModalPopup.vue?vue&type=script&lang=ts&"
export * from "./JdhAttachedModalPopup.vue?vue&type=script&lang=ts&"
import style0 from "./JdhAttachedModalPopup.vue?vue&type=style&index=0&id=0bc8bdde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc8bdde",
  null
  
)

export default component.exports